import React from "react";
import AllCategories from "./AllCategories";
import Partners from "./Partners";
import bgcategorypartner from "../../assets/HomeImages/bgcategoryandpartner.webp";

const CategoryPartner = () => {
  const backgroundStyle = {
    backgroundImage: `url(${bgcategorypartner})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    padding: "20px 0",
  };

  return (
    <div style={backgroundStyle}>
      <AllCategories />
      <Partners />
    </div>
  );
};

export default CategoryPartner;
